import { createSvgIcon } from '@mui/material';

export const HR = createSvgIcon(
  <svg
    id='uuid-adee9737-17b4-4d67-b7db-0d539dff0d56'
    data-name='Layer 1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 76 76'
  >
    <defs>
      <linearGradient
        id='uuid-1edb7a12-f4f5-40d4-9b8b-2f6c9bd5f92c'
        x1='38.13'
        y1='47.42'
        x2='38.13'
        y2='35.84'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#8cb9fe' />
        <stop offset='1' stopColor='#2962ff' />
      </linearGradient>
      <linearGradient
        id='uuid-0502fcd7-a9b7-41ab-9b2f-7c19bd156bc7'
        x1='30.83'
        y1='47.01'
        x2='44.03'
        y2='25.11'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#fcba73' />
        <stop offset='1' stopColor='#c86904' />
      </linearGradient>
      <linearGradient
        id='uuid-430dc98e-6828-429f-8fb5-57ba47c937cb'
        x1='19.57'
        y1='58.87'
        x2='63.49'
        y2='12.22'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#8cb9fe' />
        <stop offset='1' stopColor='#2962ff' />
      </linearGradient>
      <linearGradient
        id='uuid-f3065c93-9364-4ed9-bd59-29e7a1b21e1d'
        x1='12.05'
        y1='22.78'
        x2='25.71'
        y2='9.12'
        gradientTransform='translate(0 77) scale(1 -1)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#414cc8' />
        <stop offset='1' stopColor='#2b3493' />
      </linearGradient>
    </defs>
    <path
      d='M47.66,39.54c-.89-.89-2.06-1.42-3.3-1.51.51-.87.84-1.83.96-2.84h6.61c.4,0,.79.16,1.07.44.28.28.44.67.44,1.07v.5c0,1.91-1.72,3.86-4.65,4.02-.26-.63-.64-1.21-1.13-1.7ZM30.81,35.19c.12,1.01.45,1.97.96,2.84-1.24.09-2.41.62-3.3,1.51-.49.49-.87,1.06-1.13,1.69-2.86-.2-4.54-2.14-4.54-4.02v-.5c0-.4.16-.79.44-1.07.28-.28.67-.44,1.07-.44h6.49ZM29.81,29.45c-.52-.52-1.23-.81-1.96-.81s-1.44.29-1.96.81c-.52.52-.81,1.23-.81,1.96s.29,1.44.81,1.96c.52.52,1.23.81,1.96.81s1.44-.29,1.96-.81c.52-.52.81-1.23.81-1.96s-.29-1.44-.81-1.96ZM50.37,29.45c-.52-.52-1.23-.81-1.96-.81s-1.44.29-1.96.81c-.52.52-.81,1.23-.81,1.96s.29,1.44.81,1.96,1.23.81,1.96.81,1.44-.29,1.96-.81.81-1.23.81-1.96-.29-1.44-.81-1.96Z'
      fill='url(#uuid-1edb7a12-f4f5-40d4-9b8b-2f6c9bd5f92c)'
      fillRule='evenodd'
      strokeWidth='0'
    />
    <path
      d='M44.62,40.71c.75,0,1.46.3,1.99.82.53.53.82,1.24.82,1.99v.94c0,3.69-3.49,7.5-9.37,7.5s-9.37-3.8-9.37-7.5v-.94c0-.75.3-1.46.82-1.99.53-.53,1.24-.82,1.99-.82h13.12ZM38.06,28.53c1.37,0,2.68.54,3.64,1.51.97.97,1.51,2.28,1.51,3.64s-.54,2.68-1.51,3.64c-.97.97-2.28,1.51-3.64,1.51s-2.68-.54-3.64-1.51c-.97-.97-1.51-2.28-1.51-3.64s.54-2.68,1.51-3.64c.97-.97,2.28-1.51,3.64-1.51Z'
      fill='#c86904'
      strokeWidth='0'
    />
    <path
      d='M44.62,39.99c.75,0,1.46.3,1.99.82.53.53.82,1.24.82,1.99v.94c0,3.69-3.49,7.5-9.37,7.5s-9.37-3.8-9.37-7.5v-.94c0-.75.3-1.46.82-1.99.53-.53,1.24-.82,1.99-.82h13.12ZM38.06,27.8c1.37,0,2.68.54,3.64,1.51.97.97,1.51,2.28,1.51,3.64s-.54,2.68-1.51,3.64c-.97.97-2.28,1.51-3.64,1.51s-2.68-.54-3.64-1.51c-.97-.97-1.51-2.28-1.51-3.64s.54-2.68,1.51-3.64c.97-.97,2.28-1.51,3.64-1.51Z'
      fill='url(#uuid-0502fcd7-a9b7-41ab-9b2f-7c19bd156bc7)'
      strokeWidth='0'
    />
    <path
      d='M62.13,56.78l-5.57-4.85c3.63-4.73,5.32-10.66,4.74-16.59-.58-5.93-3.4-11.42-7.89-15.35-4.48-3.93-10.29-6.01-16.25-5.81-5.96.19-11.62,2.65-15.83,6.86-4.22,4.22-6.67,9.88-6.86,15.83-.19,5.96,1.88,11.77,5.81,16.25s9.42,7.3,15.35,7.88c5.93.58,11.87-1.11,16.59-4.74l5.58,4.86c.28.28.62.51.99.66.37.15.77.23,1.17.23s.8-.08,1.17-.23c.37-.15.71-.38.99-.66s.51-.62.66-.99c.15-.37.23-.77.23-1.17s-.08-.8-.23-1.17c-.15-.37-.38-.71-.66-.99h-.01ZM20.62,37.65c0-3.43,1.02-6.78,2.92-9.63,1.9-2.85,4.61-5.07,7.78-6.38,3.17-1.31,6.65-1.65,10.01-.99,3.36.67,6.45,2.32,8.87,4.74,2.42,2.42,4.07,5.51,4.74,8.87.67,3.36.33,6.85-.99,10.01-1.31,3.17-3.53,5.87-6.38,7.78-2.85,1.9-6.2,2.92-9.63,2.92-4.6,0-9-1.83-12.25-5.08-3.25-3.25-5.08-7.65-5.08-12.25Z'
      fill='url(#uuid-430dc98e-6828-429f-8fb5-57ba47c937cb)'
      strokeWidth='0'
    />
    <path
      d='M9.4,55.88c1.27-4.54,5.44-7.88,10.4-7.88s8.89,3.15,10.28,7.51h1.71c4.7,0,8.51,3.81,8.51,8.51s-3.81,8.51-8.51,8.51H11.9c-4.7,0-8.51-3.81-8.51-8.51,0-3.83,2.53-7.08,6.02-8.14Z'
      fill='url(#uuid-f3065c93-9364-4ed9-bd59-29e7a1b21e1d)'
      fillRule='evenodd'
      strokeWidth='0'
    />
    <path
      d='M6.96,53.53c2.07-5.05,7.04-8.61,12.84-8.61,5.37,0,10.02,3.05,12.33,7.51,6.25.18,11.26,5.29,11.26,11.58s-5.19,11.59-11.59,11.59H11.9c-6.4,0-11.59-5.19-11.59-11.59,0-4.64,2.72-8.64,6.66-10.49ZM9.4,55.88c1.27-4.54,5.44-7.88,10.4-7.88s8.89,3.15,10.28,7.51h1.71c4.7,0,8.51,3.81,8.51,8.51s-3.81,8.51-8.51,8.51H11.9c-4.7,0-8.51-3.81-8.51-8.51,0-3.83,2.53-7.08,6.02-8.14Z'
      fill='#fff'
      fillRule='evenodd'
      strokeWidth='0'
    />
    <path
      d='M19.6,60h1.74v7.54h-1.74v-7.54ZM16.18,67.54h-1.74v-7.54h1.74v7.54ZM19.73,64.45h-3.68v-1.48h3.68v1.48ZM23.13,67.54v-7.54h3.26c.67,0,1.26.11,1.74.33.49.22.87.53,1.13.94.27.41.4.9.4,1.46s-.13,1.04-.4,1.45c-.27.4-.64.71-1.13.93-.49.22-1.07.32-1.74.32h-2.29l.78-.76v2.86h-1.74ZM27.92,67.54l-1.88-2.74h1.86l1.91,2.74h-1.88ZM24.87,64.87l-.78-.82h2.2c.54,0,.94-.11,1.21-.34.27-.24.4-.56.4-.97s-.13-.74-.4-.97c-.27-.23-.67-.34-1.21-.34h-2.2l.78-.83v4.28Z'
      fill='#252c7e'
      strokeWidth='0'
    />
    <path
      d='M19.6,59.38h1.74v7.54h-1.74v-7.54ZM16.18,66.92h-1.74v-7.54h1.74v7.54ZM19.73,63.83h-3.68v-1.48h3.68v1.48ZM23.13,66.92v-7.54h3.26c.67,0,1.26.11,1.74.33.49.22.87.53,1.13.94.27.41.4.9.4,1.46s-.13,1.04-.4,1.45c-.27.4-.64.71-1.13.93-.49.22-1.07.32-1.74.32h-2.29l.78-.76v2.86h-1.74ZM27.92,66.92l-1.88-2.74h1.86l1.91,2.74h-1.88ZM24.87,64.25l-.78-.82h2.2c.54,0,.94-.11,1.21-.34.27-.24.4-.56.4-.97s-.13-.74-.4-.97c-.27-.23-.67-.34-1.21-.34h-2.2l.78-.83v4.28Z'
      fill='#fff'
      strokeWidth='0'
    />
  </svg>,
  'HR',
);
